import SubscriptionRow from 'dashboard-subscriptions/components/SubscriptionRow'

const SubscriptionsList = ({ subscriptions, selectedTab, openSubscription }) =>
    subscriptions.map((subscription, index) =>
        subscription.products ? (
            <SubscriptionRow
                subscription={subscription}
                key={index}
                selectedType={selectedTab}
                openSubscription={initialTab => openSubscription(index, initialTab)}
            />
        ) : null
    )

export default SubscriptionsList
